if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      this.prefetchCache = new Map();
      this.sectionCache = new Map();
      this.preloadedImages = new Set();
      this.variantData = null;
      this.variantRequestId = 0;

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
      this.addEventListener('click', this.onVariantClick);
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.updateOptionAvailabilityStates();
      this.setImageSet();
      this.prefetchProductUrls();
      this.prefetchVariantSections();

      // Pre-fetch availability for the initially selected color immediately
      const colorFieldset = this.querySelector('.product-form__input--color');
      if (colorFieldset) {
        const selectedColor = this.getSelectedOptionElement(colorFieldset)?.value;
        if (selectedColor) {
          // Fetch immediately with a small delay to not block page render
          setTimeout(() => this.fetchColorAvailability(selectedColor), 100);
        }
      }

      // Set up hover/focus prefetch for all other colors
      this.setupColorPrefetch();
    }

    onVariantChange(event) {

       // ADD THIS — ignore change events from unavailable inputs
      if (event?.target?.classList.contains('is-unavailable')) {
        return;
     }
      this.updateOptions();
      this.updateOptionAvailabilityStates();

      const changedFieldset = event?.target?.closest('fieldset');
      this.selectFallbackForColorChange(changedFieldset);
      this.updateOptions();
      this.updateOptionAvailabilityStates();

      // If color changed, immediately kick off availability fetch for new color
      if (changedFieldset && changedFieldset.classList.contains('product-form__input--color')) {
        const newColor = this.getSelectedOptionElement(changedFieldset)?.value;
        if (newColor && !this._fetchedColors?.has(newColor)) {
          this.fetchColorAvailability(newColor);
        }
      }

      if (this.handleSaleGroupSelection(event)) {
        return;
      }
      this.removeErrorMessage();
      this.updateVariantText();

      const productUrl = this.getProductUrl();
      if (!productUrl) {
        const localVariant = this.getVariantFromOptions();
        if (localVariant) {
        this.currentVariant = localVariant;
        this.updateVariantInput();
        if (this.updateUrl) this.updateURL();
        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        this.updatePickupAvailability();
      } else {
        // Could be a beyond-250 variant — check the selected inputs directly
        const selectedInputs = this.fieldsets.map(f => {
          const checked = f.querySelector('input:checked');
          return checked ? checked.dataset.available : null;
        });
        const allFound = selectedInputs.every(v => v !== null);
        const allAvailable = selectedInputs.every(v => v === 'true');

        if (allFound && allAvailable) {
        // All selected options are marked available server-side
        // so this is a real variant that's just beyond the 250 cap
        // Let renderVariantInfo handle it via the server fetch
        this.toggleAddButton(false, false, false);
        } else {
        this.toggleAddButton(true, '', false);
        }
      }
      } else {
        this.toggleAddButton(true, '', false);
      }

      this.renderVariantInfo();

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }
    getSelectedOptionElement(fieldset) {
      if (!fieldset) return null;
      const select = fieldset.querySelector('select');
      if (select) {
        return select.selectedOptions[0] || null;
      }
      return fieldset.querySelector('input:checked');
    }
    areOptionValuesEqual(first, second) {
      return String(first || '').trim() === String(second || '').trim();
    }
    

selectFallbackForColorChange(changedFieldset) {
  if (!changedFieldset || !changedFieldset.classList.contains('product-form__input--color')) return false;
  const selectedColor = this.getSelectedOptionElement(changedFieldset)?.value;
  if (!selectedColor) return false;

  const colorIndex = parseInt(changedFieldset.dataset.optionPosition, 10) - 1;
  const currentSelections = this.fieldsets.map((fieldset) => {
    if (fieldset === changedFieldset) return selectedColor;
    const selected = this.getSelectedOptionElement(fieldset);
    return selected ? selected.value : null;
  });

  const scoreVariant = (variant) => {
    if (!variant) return 2;
    return variant.available ? 0 : 1;
  };

  // Check the state of the current size in the new color
  const currentVariant = this.getVariantData().find((variant) => {
    return variant.options.every((optionValue, index) =>
      this.areOptionValuesEqual(optionValue, currentSelections[index])
    );
  });

  const currentScore = scoreVariant(currentVariant); // 0=available, 1=out-of-stock, 2=unavailable

  // If current size is already available in new color — no action needed
  if (currentScore === 0) return false;

  // Current size is out-of-stock or unavailable — try to find a better option
  let bestVariant = null;
  let bestScore = currentScore; // only switch if we find something BETTER than current

  // Pass 1: try to match other non-color selections as closely as possible
  this.getVariantData().forEach((variant) => {
    if (!this.areOptionValuesEqual(variant.options[colorIndex], selectedColor)) return;

    const score = scoreVariant(variant);
    if (score >= bestScore) return; // not better than what we have

    const matchesOthers = this.fieldsets.every((fieldset, index) => {
      if (fieldset === changedFieldset) return true;
      const selected = this.getSelectedOptionElement(fieldset);
      if (!selected) return true;
      return this.areOptionValuesEqual(variant.options[index], selected.value);
    });

    if (matchesOthers) {
      bestScore = score;
      bestVariant = variant;
    }
  });

  // Pass 2: no close match found — try ANY variant for this color that is better
  if (!bestVariant) {
    this.getVariantData().forEach((variant) => {
      if (!this.areOptionValuesEqual(variant.options[colorIndex], selectedColor)) return;
      const score = scoreVariant(variant);
      if (score < bestScore) {
        bestScore = score;
        bestVariant = variant;
      }
    });
  }

  // Nothing better found — keep current selection as-is
  if (!bestVariant) return false;

  // Apply the better selection
  let changed = false;
  this.fieldsets.forEach((fieldset, index) => {
    if (fieldset === changedFieldset) return;
    const selected = this.getSelectedOptionElement(fieldset);
    const targetValue = bestVariant.options[index];
    if (!selected || !this.areOptionValuesEqual(selected.value, targetValue)) {
      if (this.selectOptionValue(fieldset, targetValue)) {
        changed = true;
      }
    }
  });

  return changed;
}


    selectOptionValue(fieldset, value) {
      if (!fieldset || !value) return false;

      const select = fieldset.querySelector('select');
      if (select) {
        const targetOption = Array.from(select.options).find((option) => option.value === value);
        if (!targetOption || select.value === value) return false;
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      const targetInput = Array.from(fieldset.querySelectorAll('input')).find((input) => input.value === value);
      if (!targetInput || targetInput.checked) return false;
      targetInput.checked = true;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    handleSaleGroupSelection(event) {
      const trigger = event?.target;
      const primaryFieldset = this.querySelector('fieldset[data-option-position="1"]');
      const secondaryFieldset = this.querySelector('fieldset[data-option-position="2"]');

      if (!trigger || !primaryFieldset || !secondaryFieldset || !primaryFieldset.contains(trigger)) {
        return false;
      }

      const selectedPrimary = this.getSelectedOptionElement(primaryFieldset);
      if (!selectedPrimary || selectedPrimary.dataset.sale !== 'true') {
        return false;
      }

      const saleTargetValue = selectedPrimary.dataset.saleSecondaryValue;
      if (!saleTargetValue) {
        return false;
      }

      return this.selectOptionValue(secondaryFieldset, saleTargetValue);
    }

    onVariantClick(event) {
      const target = event.target;
      if (!target) return;

      const label = target.closest('label');
      const clickedInput = target.tagName === 'INPUT'
        ? target
        : label
          ? this.querySelector(`#${label.htmlFor}`)
          : null;
         // ADD THIS — block clicks on unavailable inputs entirely
        if (clickedInput && clickedInput.classList.contains('is-unavailable')) {
        event.preventDefault();
        event.stopPropagation();
        return;
       }
      if (!clickedInput || clickedInput.dataset.available !== 'false') return;

      const fieldset = clickedInput.closest('fieldset');
      if (!fieldset || fieldset.querySelector('select')) return;
      if (fieldset.classList.contains('product-form__input--color')) return;

      const optionPosition = parseInt(fieldset.dataset.optionPosition, 10) - 1;
      const currentSelections = this.fieldsets.map((fieldsetItem, index) => {
        if (index === optionPosition) return null;
        const selected = this.getSelectedOptionElement(fieldsetItem);
        return selected ? selected.value : null;
      });

      const availableVariants = this.getVariantData().filter((variant) => {
        if (!variant.available) return false;
        return variant.options.every((optionValue, index) => {
          if (index === optionPosition) return true;
          return currentSelections[index] === null || currentSelections[index] === optionValue;
        });
      });

      if (!availableVariants.length) return;

      const fallbackValue = availableVariants[0].options[optionPosition];
      if (!fallbackValue) return;

      event.preventDefault();
      event.stopPropagation();
      this.selectOptionValue(fieldset, fallbackValue);
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    updateOptionAvailabilityStates() {
      const variations = this.querySelector('.variations');
      if (variations) variations.classList.add('updating');

      const colorFieldset = this.querySelector('.product-form__input--color');
      if (!colorFieldset) {
        if (variations) variations.classList.remove('updating');
        return;
      }

      const selectedColor = this.getSelectedOptionElement(colorFieldset)?.value;
      if (!selectedColor) {
        if (variations) variations.classList.remove('updating');
        return;
      }

      const colorSizeMap = this.buildColorSizeMap();
      const colorMap = colorSizeMap[selectedColor] || {};
      let hasGaps = false;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset === colorFieldset) return;

        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]'));

        inputs.forEach((input) => {
          const optionValue = input.value;
          const label = this.querySelector(`label[for="${input.id}"]`);
          let state;

          if (colorMap[optionValue] !== undefined) {
            state = colorMap[optionValue];
          } else {
            // Not in local 250 data for this color
            // Show as available temporarily while we fetch accurate data
            state = 'is-available';
            hasGaps = true;
          }

          this.applyOptionState(input, label, state);
        });

        // Handle select dropdowns
        const select = fieldset.querySelector('select');
        if (select) {
          Array.from(select.options).forEach((option) => {
            const optionValue = option.value;
            let state;

            if (colorMap[optionValue] !== undefined) {
              state = colorMap[optionValue];
            } else {
              state = 'is-available';
              hasGaps = true;
            }

            option.classList.remove('is-available', 'is-out-of-stock', 'is-unavailable');
            option.classList.add(state);
            option.disabled = state === 'is-unavailable';
            option.dataset.available = state === 'is-unavailable' ? 'false' : 'true';
          });
        }
      });

      // If gaps exist, trigger background fetch for this color
      if (hasGaps && !this._fetchedColors?.has(selectedColor)) {
        this.fetchColorAvailability(selectedColor);
      }

      if (variations) variations.classList.remove('updating');
      void this.offsetHeight;
    }

    applyOptionState(input, label, state) {
      const states = ['is-available', 'is-out-of-stock', 'is-unavailable'];
      states.forEach((stateClass) => {
        input.classList.remove(stateClass);
        if (label) label.classList.remove(stateClass);
      });

      input.classList.add(state);
      if (label) label.classList.add(state);
      input.dataset.available = state === 'is-unavailable' ? 'false' : 'true';

      if (state === 'is-unavailable') {
        input.disabled = true;
        input.setAttribute('aria-disabled', 'true');
        if (label) {
          label.style.opacity = '0.4';
          label.style.cursor = 'not-allowed';
          label.style.pointerEvents = 'none';
        }
      } else {
        input.disabled = false;
        input.removeAttribute('aria-disabled');
        if (label) {
          label.style.opacity = '';
          label.style.cursor = '';
          label.style.pointerEvents = '';
        }
      }
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const localVariant = this.getVariantFromOptions();
      if (localVariant) {
        this.currentVariant = localVariant;
        this.updateQuantityInput();
        return;
      }

      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = this.getVariantFromElement(span);
      this.updateQuantityInput();
    }

    getVariantFromElement(element) {
      return {
        id: parseInt(element.dataset.variantId, 10) || null,
        available: element.dataset.available === 'true',
        featured_media: element.dataset.featuredMediaId ? { id: parseInt(element.dataset.featuredMediaId, 10) } : null,
        quantity_rule: {
          min: Number(element.dataset.quantityRuleMin) || 1,
          max: element.dataset.quantityRuleMax ? Number(element.dataset.quantityRuleMax) : null,
          increment: Number(element.dataset.quantityRuleIncrement) || 1
        },
        inventory_management: element.dataset.inventoryManagement || null,
        inventory_policy: element.dataset.inventoryPolicy || null,
        inventory_quantity: Number(element.dataset.inventoryQuantity) || 0
      };
    }

    getQuantityMaxForVariant(variant) {
      if (!variant) return null;

      let max = variant.quantity_rule && variant.quantity_rule.max !== null ? Number(variant.quantity_rule.max) : null;

      if (variant.inventory_management && variant.inventory_policy !== 'continue' && variant.inventory_quantity > 0) {
        max = max !== null ? Math.min(max, variant.inventory_quantity) : variant.inventory_quantity;
      }

      return max;
    }

    updateQuantityInput() {
      const quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
      if (!quantityInput || !this.currentVariant) return;

      const min = this.currentVariant.quantity_rule ? this.currentVariant.quantity_rule.min : 1;
      const increment = this.currentVariant.quantity_rule ? this.currentVariant.quantity_rule.increment : 1;
      const max = this.getQuantityMaxForVariant(this.currentVariant);

      quantityInput.setAttribute('min', min);
      quantityInput.dataset.min = min;
      quantityInput.setAttribute('step', increment);

      if (max !== null) {
        quantityInput.setAttribute('max', max);
        quantityInput.dataset.max = max;
        if (Number(quantityInput.value) > max) quantityInput.value = max;
      } else {
        quantityInput.removeAttribute('max');
        delete quantityInput.dataset.max;
      }

      if (Number(quantityInput.value) < min || isNaN(Number(quantityInput.value))) {
        quantityInput.value = min;
      }

      const quantitySelector = quantityInput.closest('quantity-selector');
      if (quantitySelector && typeof quantitySelector.updateButtonState === 'function') {
        quantitySelector.updateButtonState(Number(quantityInput.value));
      }
    }

    getVariantData() {
      if (this.variantData) return this.variantData;

      const script = this.querySelector(`#ProductVariants-${this.dataset.section}`);
      if (!script) {
        this.variantData = [];
        return this.variantData;
      }

      try {
        this.variantData = JSON.parse(script.textContent).map((variant) => ({
          id: variant.id,
          available: variant.available,
          options: variant.options || [],
          quantity_rule: variant.quantity_rule || {
            min: 1,
            max: null,
            increment: 1
          },
          inventory_management: variant.inventory_management || null,
          inventory_policy: variant.inventory_policy || null,
          inventory_quantity: Number(variant.inventory_quantity) || 0,
          featured_media: variant.featured_media ? { id: variant.featured_media.id } : (variant.featured_image ? { id: variant.featured_image.id } : null)
        }));
      } catch (e) {
        this.variantData = [];
      }

      return this.variantData;
    }

    buildColorSizeMap() {
      if (this._colorSizeMap) return this._colorSizeMap;

      // Initialize with empty map — server fetches will populate beyond-250 entries
      this._colorSizeMap = {};

      // Find which fieldset index is color and which is size
      const colorFieldset = this.querySelector('.product-form__input--color');
      if (!colorFieldset) return this._colorSizeMap;

      const colorIndex = parseInt(colorFieldset.dataset.optionPosition, 10) - 1;

      this.getVariantData().forEach((variant) => {
        const color = variant.options[colorIndex];
        if (!color) return;

        if (!this._colorSizeMap[color]) {
          this._colorSizeMap[color] = {};
        }

         variant.options.forEach((optionValue, idx) => {
          if (idx === colorIndex) return;
          // Only set if not already set to avoid overwriting 'is-available' with 'is-out-of-stock'
          if (!this._colorSizeMap[color][optionValue]) {
            this._colorSizeMap[color][optionValue] = variant.available ? 'is-available' : 'is-out-of-stock';
          } else if (variant.available) {
            // If any variant with this combo is available, mark as available
            this._colorSizeMap[color][optionValue] = 'is-available';
         }
        });
      });

      return this._colorSizeMap;
    }

    async fetchColorAvailability(color) {
      if (!this._fetchedColors) this._fetchedColors = new Set();
      if (!this._pendingColorFetches) this._pendingColorFetches = {};

      if (this._fetchedColors.has(color)) return;
      if (this._pendingColorFetches[color]) return this._pendingColorFetches[color];

      const colorFieldset = this.querySelector('.product-form__input--color');
      if (!colorFieldset) return;

      const colorInput = Array.from(colorFieldset.querySelectorAll('input')).find(
        input => input.value === color
      );
      if (!colorInput || !colorInput.dataset.valueId) return;

      const colorValueId = colorInput.dataset.valueId;

      const otherFieldsets = this.fieldsets.filter(f => f !== colorFieldset);
      if (!otherFieldsets.length) return;

      this._pendingColorFetches[color] = (async () => {
        try {
          // Collect all size inputs across all non-color fieldsets
          const allSizeInputs = [];
          otherFieldsets.forEach(fieldset => {
            fieldset.querySelectorAll('input[data-value-id]').forEach(input => {
              allSizeInputs.push(input);
            });
          });

          // Fetch ALL sizes in parallel instead of one by one
          await Promise.all(allSizeInputs.map(async (sizeInput) => {
            const sizeValueId = sizeInput.dataset.valueId;
            if (!sizeValueId) return;

            const ids = [colorValueId, sizeValueId];
            const cacheKey = this.getSectionCacheKey(ids);

            try {
              const responseText = await this.fetchSection(cacheKey, cacheKey);
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);

              const sizeValue = sizeInput.value;
              if (!this._colorSizeMap[color]) this._colorSizeMap[color] = {};

              if (span && parseInt(span.dataset.variantId, 10)) {
                const available = span.dataset.available === 'true';
                if (available || !this._colorSizeMap[color][sizeValue]) {
                  this._colorSizeMap[color][sizeValue] = available ? 'is-available' : 'is-out-of-stock';
                }
              } else {
                if (!this._colorSizeMap[color][sizeValue]) {
                  this._colorSizeMap[color][sizeValue] = 'is-unavailable';
                }
              }
            } catch (e) {
              // Skip on error
            }
          }));

          this._fetchedColors.add(color);

          // Re-run availability with complete data
          this.updateOptionAvailabilityStates();
          this.setDisabled();

        } finally {
          delete this._pendingColorFetches[color];
        }
      })();

      return this._pendingColorFetches[color];
    }

    setupColorPrefetch() {
      const colorFieldset = this.querySelector('.product-form__input--color');
      if (!colorFieldset) return;

      colorFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = this.querySelector(`label[for="${input.id}"]`);
        const triggerPrefetch = () => {
          const color = input.value;
          if (!this._fetchedColors?.has(color) && !this._pendingColorFetches?.[color]) {
            this.fetchColorAvailability(color);
          }
        };

        // Start fetching on hover or focus — before the click happens
        if (label) {
          label.addEventListener('mouseenter', triggerPrefetch, { once: true });
          label.addEventListener('focus', triggerPrefetch, { once: true });
          label.addEventListener('touchstart', triggerPrefetch, { once: true, passive: true });
        }
        input.addEventListener('focus', triggerPrefetch, { once: true });
      });
    }

    getVariantFromOptions(options = this.options) {
      if (!options || !options.length) return null;

      return this.getVariantData().find((variant) => {
        return variant.options.length === options.length && variant.options.every((option, index) => this.areOptionValuesEqual(option, options[index]));
      }) || null;
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].updateOptionAvailabilityStates();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      this.setActiveMedia(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        if (this.thumbnails) {
          let currentThumb = this.thumbnails.querySelector('.product-thumbnail.is-initial-selected');
          if (currentThumb) {
            currentThumb.classList.remove('is-initial-selected');
          }
          let activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-initial-selected');
          }
        }
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      this.updateQuantityInput();
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      pickUpAvailability.update(this.currentVariant);
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `selected-variant-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `variant-tab1-${this.dataset.section}`, `variant-tab2-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    prefetchProductUrls() {
      const sectionId = this.dataset.section;
      const seen = new Set();
      const urls = [];

      this.querySelectorAll('[data-product-url]').forEach((el) => {
        const url = el.dataset.productUrl;
        if (!url || url === this.dataset.url || seen.has(url)) return;
        seen.add(url);
        urls.push(url);

        const hoverTarget = el.tagName === 'OPTION' ? el.closest('select') : this.querySelector('label[for="' + el.id + '"]');
        if (!hoverTarget) return;

        const prefetch = () => {
          if (!this.prefetchCache.has(url)) {
            this.prefetchCache.set(url, this.fetchSection(url, url + '?section_id=' + sectionId));
          }
        };

        hoverTarget.addEventListener('mouseenter', prefetch, { once: true });
        hoverTarget.addEventListener('focus', prefetch, { once: true });
        hoverTarget.addEventListener('touchstart', prefetch, { once: true, passive: true });
      });

      const warmProductUrls = () => {
        urls.slice(0, 20).forEach((url) => {
          if (!this.prefetchCache.has(url)) {
            this.prefetchCache.set(url, this.fetchSection(url, url + '?section_id=' + sectionId));
          }
        });
      };

      if (urls.length && 'requestIdleCallback' in window) {
        window.requestIdleCallback(warmProductUrls, { timeout: 2000 });
      } else if (urls.length) {
        window.setTimeout(warmProductUrls, 600);
      }
    }

    getSectionCacheKey(ids) {
      return `${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`;
    }

    fetchSection(cacheKey, url) {
      if (!this.sectionCache.has(cacheKey)) {
        this.sectionCache.set(cacheKey, fetch(url).then((response) => response.text()).then((responseText) => {
          this.preloadImagesFromHTML(responseText);
          return responseText;
        }).catch((error) => {
          this.sectionCache.delete(cacheKey);
          throw error;
        }));
      }

      return this.sectionCache.get(cacheKey);
    }

    preloadImagesFromHTML(responseText) {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      html.querySelectorAll(`#MediaGallery-${this.dataset.section} img`).forEach((img) => {
        const urls = [];
        const src = img.getAttribute('src') || img.getAttribute('data-src');
        const srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset');

        if (src) urls.push(src);
        if (srcset) {
          srcset.split(',').forEach((candidate) => {
            const url = candidate.trim().split(/\s+/)[0];
            if (url) urls.push(url);
          });
        }

        urls.forEach((url) => {
          if (this.preloadedImages.has(url)) return;
          this.preloadedImages.add(url);
          const image = new Image();
          image.decoding = 'async';
          image.src = url;
        });
      });
    }

    revealLazyImages(container) {
      if (!container) return;

      container.querySelectorAll('img').forEach((img) => {
        if (img.dataset.srcset && !img.getAttribute('srcset')) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.dataset.src && (!img.getAttribute('src') || img.getAttribute('src').includes('width=20'))) {
          img.setAttribute('src', img.dataset.src);
        }
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        img.classList.remove('lazyload');
      });
    }

    getValueIdMatrix() {
      return this.fieldsets.map((fieldset) => {
        const values = [];
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option[data-value-id]').forEach((option) => {
            if (option.dataset.valueId) values.push(option.dataset.valueId);
          });
        } else {
          fieldset.querySelectorAll('input[data-value-id]').forEach((input) => {
            if (input.dataset.valueId) values.push(input.dataset.valueId);
          });
        }
        return [...new Set(values)];
      }).filter((values) => values.length);
    }

    prefetchVariantSections() {
      const matrix = this.getValueIdMatrix();
      if (!matrix.length) return;

      const combinations = matrix.reduce((acc, values) => {
        const next = [];
        acc.forEach((combo) => {
          values.forEach((value) => next.push([...combo, value]));
        });
        return next;
      }, [[]]).slice(0, 40);

      const warmCache = () => {
        combinations.forEach((ids) => {
          const cacheKey = this.getSectionCacheKey(ids);
          this.fetchSection(cacheKey, cacheKey).catch(() => {});
        });
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmCache, { timeout: 1500 });
      } else {
        window.setTimeout(warmCache, 400);
      }
    }

    getProductUrl() {
      for (let i = 0; i < this.fieldsets.length; i++) {
        const fieldset = this.fieldsets[i];
        const select = fieldset.querySelector('select');
        let productUrl;
        if (select && select.selectedOptions[0]) {
          productUrl = select.selectedOptions[0].dataset.productUrl;
        } else {
          const checked = fieldset.querySelector('input:checked');
          productUrl = checked ? checked.dataset.productUrl : null;
        }
        if (productUrl && productUrl !== this.dataset.url) {
          return productUrl;
        }
      }
      return null;
    }

    switchProduct(productUrl) {
      const sectionId = this.dataset.section;
      const fetchUrl = productUrl + '?section_id=' + sectionId;

      const responsePromise = this.prefetchCache.has(productUrl) ? this.prefetchCache.get(productUrl) : this.fetchSection(productUrl, fetchUrl);

      const scrollY = window.scrollY;

      return responsePromise.then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newSection = html.querySelector('#shopify-section-' + sectionId);
        const currentSection = document.getElementById('shopify-section-' + sectionId);

        if (newSection && currentSection) {
          currentSection.style.visibility = 'hidden';
          currentSection.innerHTML = newSection.innerHTML;
          this.revealLazyImages(currentSection);
          requestAnimationFrame(function () {
            currentSection.style.visibility = '';
          });

          const slider = currentSection.querySelector('product-slider');
          if (slider) {
            const images = slider.querySelectorAll('.product-images__slide img');
            let loaded = 0;
            const total = images.length;
            const onLoad = function () {
              loaded++;
              if (loaded >= total) {
                const flkty = Flickity.data(slider);
                if (flkty) {
                  flkty.resize();
                }
              }
            };
            images.forEach(function (img) {
              if (img.complete) {
                onLoad();
              } else {
                img.addEventListener('load', onLoad, { once: true });
                img.addEventListener('error', onLoad, { once: true });
              }
            });
          }
        }

        window.history.replaceState({}, '', productUrl);
        requestAnimationFrame(function () {
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        });
      });
    }

    renderVariantInfo() {
      const requestId = ++this.variantRequestId;
      // Combined listings: check if selected option links to a different product
      const productUrl = this.getProductUrl();
      if (productUrl) {
        this.switchProduct(productUrl);
        return;
      }

      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;
      const cacheKey = this.getSectionCacheKey(ids);

      this.fetchSection(cacheKey, cacheKey)
        .then((responseText) => {
          if (requestId !== this.variantRequestId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const currentGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
          const sourceGallery = html.getElementById(`MediaGallery-${this.dataset.section}`);

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);

          // Combined listings fallback: response resolved to a different product
          if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
            this.switchProduct(span.dataset.productUrl);
            return;
          }
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = this.getVariantFromElement(span);
            // Feed this result back into colorSizeMap so future availability checks are accurate
            if (this.options && this.options.length >= 2) {
              const colorFieldset = this.querySelector('.product-form__input--color');
              if (colorFieldset) {
                const colorIndex = parseInt(colorFieldset.dataset.optionPosition, 10) - 1;
                const color = this.options[colorIndex];
                if (color) {
                  if (!this._colorSizeMap) this._colorSizeMap = {};
                  if (!this._colorSizeMap[color]) this._colorSizeMap[color] = {};
                  this.options.forEach((optionValue, idx) => {
                    if (idx === colorIndex) return;
                    this._colorSizeMap[color][optionValue] = this.currentVariant.available
                      ? 'is-available'
                      : 'is-out-of-stock';
                  });
                }
              }
            }
          } else {
            this.currentVariant = null;
            // Mark this combo as unavailable in the map
            if (this.options && this.options.length >= 2) {
              const colorFieldset = this.querySelector('.product-form__input--color');
              if (colorFieldset) {
                const colorIndex = parseInt(colorFieldset.dataset.optionPosition, 10) - 1;
                const color = this.options[colorIndex];
                if (color) {
                  if (!this._colorSizeMap) this._colorSizeMap = {};
                  if (!this._colorSizeMap[color]) this._colorSizeMap[color] = {};
                  this.options.forEach((optionValue, idx) => {
                    if (idx === colorIndex) return;
                    if (!this._colorSizeMap[color][optionValue]) {
                      this._colorSizeMap[color][optionValue] = 'is-unavailable';
                    }
                  });
                }
              }
            }
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // Recompute option states after the server response updates availability metadata.
          this.updateOptionAvailabilityStates();

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          if (currentGallery && sourceGallery) {
            const currentSlider = currentGallery.querySelector('product-slider');
            const currentFlickity = currentSlider ? Flickity.data(currentSlider) : null;

            if (currentFlickity) {
              currentFlickity.destroy();
            }

            currentGallery.innerHTML = sourceGallery.innerHTML;
            this.revealLazyImages(currentGallery);
            this.productSlider = this.productWrapper.querySelector('.product-images');
          } else if (currentGallery) {
            currentGallery.innerHTML = '';
            this.productSlider = null;
          }

          // 4. Apply updated state
          if (!this.currentVariant) {
            // Check if this is a beyond-250 variant using the span's data
            const spanVariantId = span ? parseInt(span.dataset.variantId, 10) : 0;
            const spanAvailable = span ? span.dataset.available === 'true' : false;

            if (spanVariantId) {
            // Variant exists on server but is beyond our 250 local cap
           // Reconstruct currentVariant from the span data
            this.currentVariant = this.getVariantFromElement(span);
            this.setDisabled();
            this.updateVariantInput();
            if (this.updateUrl) this.updateURL();
            this.toggleAddButton(
            !spanAvailable,
            spanAvailable ? false : window.theme.variantStrings.soldOut
             );
            this.updateMedia();
            this.updatePickupAvailability();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            } else {
            // Truly unavailable combination
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
           this.updatePickupAvailability();
           window.scrollTo({ top: scrollY, behavior: 'instant' });
            }
            return;
            }
            this.setDisabled();
            this.updateVariantInput();
            if (this.updateUrl) this.updateURL();
            this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
            this.updateMedia();
            this.updatePickupAvailability();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
        })
        .catch((error) => {
          console.error(error);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const buttons = document.querySelectorAll(`#product-form-${this.dataset.section} [name="add"], #AddToCartSticky`);

      buttons.forEach((addButton) => {
        const wrapper = addButton.closest('.product-form');
        const productTemplate = wrapper ? wrapper.getAttribute('template') : '';
        const addButtonText = addButton.querySelector('.single-add-to-cart-button--text, span');

        if (!addButtonText) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          addButton.classList.add('sold-out');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButton.classList.remove('loading', 'sold-out');

          if (productTemplate?.includes('pre-order')) {
            addButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            addButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add('sold-out');
      addButton.setAttribute('disabled', 'disabled');
      const stickyButton = document.getElementById('AddToCartSticky');
      if (stickyButton) {
        const stickyText = stickyButton.querySelector('.single-add-to-cart-button--text, span');
        stickyButton.classList.add('sold-out');
        stickyButton.setAttribute('disabled', 'disabled');
        if (stickyText) stickyText.textContent = window.theme.variantStrings.unavailable;
      }
      if (price) price.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        const isColorFieldset = fieldset.classList.contains('product-form__input--color');

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.classList.contains('is-unavailable');
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            if (isColorFieldset) {
              input.classList.remove('is-disabled');
              input.disabled = false;
            } else {
              const isUnavailable = input.classList.contains('is-unavailable');
              const isOutOfStock = input.classList.contains('is-out-of-stock');
              input.classList.toggle('is-disabled', isUnavailable);
              input.disabled = isUnavailable;
            }
          });
        }
      });
      return true;
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      const fieldset = this.fieldsets[optionPosition];
      if (!fieldset) return;
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');
      let setValue;
      if (select && select.selectedOptions[0]) {
        setValue = select.selectedOptions[0].dataset.handle;
      } else if (checked) {
        setValue = checked.dataset.handle;
      }
      if (!setValue) return;
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
            thumb.classList.remove('is-initial-selected');
          }
        });
        let firstGroupThumb = null;
        selected_set_thumbs.forEach(thumb => {
          const inGroup = thumb.dataset.group === group;
          thumb.classList.toggle('is-active', inGroup);
          if (inGroup && !firstGroupThumb) {
            firstGroupThumb = thumb;
          }
        });
        if (firstGroupThumb) {
          firstGroupThumb.classList.add('is-initial-selected');
        }
      }

    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
    updateVariantText() {


    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      }
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };

      if (this.classList.contains('product-quick-images')) {
        this.options.cellAlign = 'left';
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupZoomListeners();
    }
    reInit() {
      if (this.eventController) {
        this.eventController.abort();
      }

      this.flkty.destroy();
      this.setOptions();
      this.flkty = new Flickity(this, this.options);
      this.setupEvents();
      this.selectedIndex = this.flkty.selectedIndex;
      this.setupZoomListeners();
    }
    setupEvents() {
      this.eventController = new AbortController();
      const signal = this.eventController.signal;

      if (this.prev_button) {
        this.prev_button.addEventListener('click', () => {
          this.flkty.previous();
        }, { signal });
        this.prev_button.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        }, { signal });
      }
      if (this.next_button) {
        this.next_button.addEventListener('click', () => {
          this.flkty.next();
        }, { signal });
        this.next_button.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        }, { signal });
      }

      // Video play button overlay click handlers
      this.querySelectorAll('.product-single__media-external-video--play button').forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.closest('.product-single__media-external-video--play').setAttribute('hidden', '');
        }, { signal });
      });

      this.flkty.on('settle', (index) => {
        this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector('.product-single__media');

        if (this.thumbnail_container) {
          let mediaId = slide.dataset.mediaId,
            active_thumb = mediaId ? this.thumbnail_container.querySelector(`#Thumb-${mediaId}`) : null;

          this.thumbnails.forEach((item) => {
            item.classList.remove('is-initial-selected');
          });
          if (active_thumb) {
            active_thumb.classList.add('is-initial-selected');
            this.scrollToThumbnail(active_thumb);
          }
        }

        // Stop previous video
        this.pauseMedia(previous_media);

        // Draggable.
        if (media.classList.contains('product-single__media-model')) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }

      });

      let scrollbar = document.querySelector('.product-quick-images__scrollbar>div');

      if (scrollbar) {
        this.flkty.on('scroll', function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = 'scaleX(' + progress + ')';
        });
      }
      if (this.thumbnail_container) {
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail);
          }, { signal });
        });
      }
    }
    scrollToThumbnail(thumb) {
      requestAnimationFrame(() => {
        if (!thumb || thumb.offsetParent === null) {
          return;
        }
        const isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
        const parent = thumb.parentElement;
        const thumbLeft = thumb.offsetLeft;
        const thumbRight = thumbLeft + thumb.clientWidth;
        const visibleLeft = parent.scrollLeft;
        const visibleRight = visibleLeft + parent.clientWidth;
        const isFullyVisible = thumbLeft >= visibleLeft && thumbRight <= visibleRight;

        if (isMobileViewport && isFullyVisible) {
          return;
        }
        const windowHalfHeight = thumb.offsetParent.clientHeight / 2,
          windowHalfWidth = thumb.offsetParent.clientWidth / 2;
        parent.scrollTo({
          left: thumb.offsetLeft - windowHalfWidth + thumb.clientWidth / 2,
          top: thumb.offsetTop - windowHalfHeight + thumb.clientHeight / 2,
          behavior: isMobileViewport ? 'auto' : 'smooth'
        });
      });
    }
    pauseMedia(media) {
      if (!media) return;
      if (media.classList.contains('product-single__media-external-video')) {
        if (media.dataset.provider === 'youtube') {
          media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (media.dataset.provider === 'vimeo') {
          media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
        let playBtn = media.querySelector('.product-single__media-external-video--play');
        if (playBtn) {
          playBtn.removeAttribute('hidden');
        }
      } else if (media.classList.contains('product-single__media-native-video')) {
        media.querySelector("video").pause();
      }
    }
    thumbnailClick(thumbnail) {
      this.thumbnails.forEach(el => {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');

      let mediaId = thumbnail.id ? thumbnail.id.replace('Thumb-', '') : null;
      if (mediaId) {
        let cellIndex = this.flkty.cells.findIndex(cell => cell.element.dataset.mediaId === mediaId);
        if (cellIndex > -1) {
          this.flkty.select(cellIndex);
        }
      }
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupZoomListeners() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = Array.from(item.parentNode.parentNode.children).indexOf(item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      if (this.zoomController) {
        this.zoomController.abort();
      }
      this.zoomController = new AbortController();
      const zoomSignal = this.zoomController.signal;

      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      this.links.forEach((link) => {
        link.addEventListener('click', (e) => this.zoomClick(e, link), { signal: zoomSignal });
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
    disconnectedCallback() {
      if (this.eventController) {
        this.eventController.abort();
      }
      if (this.zoomController) {
        this.zoomController.abort();
      }
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this._onSubmit = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this._onSubmit);
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    disconnectedCallback() {
      if (this._onSubmit && this.form) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const quantityInput = this.form.querySelector('[name="quantity"]');
      let cappedQuantityMax = null;
      if (quantityInput && quantityInput.getAttribute('max') && Number(quantityInput.value) > Number(quantityInput.getAttribute('max'))) {
        cappedQuantityMax = quantityInput.getAttribute('max');
        quantityInput.value = cappedQuantityMax;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();
      if (cappedQuantityMax) {
        this.handleErrorMessage(`Only ${cappedQuantityMax} qty is available`);
      }


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              this.refreshCartContents(true);
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }].filter((section) => document.getElementById(section.id));
    }
    refreshCartContents(openDrawer = false) {
      const sections = this.getSectionsToRender();

      if (!sections.length) {
        return;
      }

      fetch(`${window.location.pathname}?sections=${sections.map((section) => section.section).join(',')}`)
        .then((response) => response.json())
        .then((sectionsState) => {
          this.renderContents({
            sections: sectionsState
          }, openDrawer);
        })
        .catch((e) => {
          console.error(e);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        });
    }
    renderContents(parsedState, openDrawer = true) {
      this.getSectionsToRender().forEach((section => {
        if (!parsedState.sections || !parsedState.sections[section.section]) {
          return;
        }
        const sectionContainer = document.getElementById(section.id);
        const elementToReplace = sectionContainer.querySelector(section.selector) || sectionContainer;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      const cartEl = document.getElementById('Cart');
      if (cartEl && cartEl.renderContents) {
        cartEl.renderContents(parsedState);
      }

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer && openDrawer) {
        document.body.classList.add('open-cc');
        document.body.style.overflow = 'hidden';
        if (typeof setSidePanelInteractivity === 'function') {
          setSidePanelInteractivity(cartDrawer, true);
        }
        cartDrawer.classList.add('active');
        cartDrawer.focus();
        dispatchCustomEvent('cart-drawer:open');
      }

      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        OverlayManager.close(product_drawer);
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (footer && entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      if (!form) return;
      _this.formPassed = false;
      this._observer = observer;
      observer.observe(form);
      if (footer) {
        observer.observe(footer);
      }
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
